import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37449800"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-color-block" }

import Button from '@/components/Button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextColorButton',
  props: {
    color: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, { class: "text-color-btn" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "text-color-block-content",
          style: _normalizeStyle({ backgroundColor: _ctx.color })
        }, null, 4)
      ])
    ]),
    _: 3
  }))
}
}

})